import React, { Component } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import gaEvent from "../../assets/js/tracking";
import './CV.scss';

class CV extends Component {
    render() {
        if (!this.props.data) return null;

        const heading = this.props.data.cv.heading;
        const subheading = this.props.data.cv.subheading;
        const cvItems = this.props.data.cv.employment.map(function (employment, index) {
            return (
                <Accordion.Item key={index} eventKey={String(index)}>
                    <Accordion.Header>
                        <div className="employment-header">
                            <span className="employer-name">{employment.employer}</span>
                            <span className="employment-meta">{employment.duration} &bull; {employment.location}</span>
                        </div>
                    </Accordion.Header>
                    <Accordion.Body>
                        <p className="employer-description">{employment.description}</p>
                        {employment.roles.map((role, roleIndex) => {
                            return (
                                <div key={roleIndex} className="content-wrapper">
                                    <h3>{role.title}</h3>
                                    <ul>
                                        {role.responsibilities.map((responsibility, responsibilityIndex) => {
                                            return (
                                                <li key={responsibilityIndex}>
                                                    <span>{responsibility.text}</span>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            );
                        })}
                    </Accordion.Body>
                </Accordion.Item>
            );
        });
        const strapline = this.props.data.cv.strapline;
        const cta = this.props.data.cv.cta;
        const link = this.props.data.cv.link;

        return (
            <div id="CV" className="section">
                <Container>
                    <Row>
                        <Col xs={12} className="col heading">
                            <AnimationOnScroll initiallyVisible={true} animateOnce={true} animateIn={'animate__pulse'}>
                                <h2>{heading}</h2>
                            </AnimationOnScroll>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} className="col section-subheading">
                            <AnimationOnScroll initiallyVisible={true} animateIn={'animate__pulse'} delay={500}>
                                <h3>{subheading}</h3>
                            </AnimationOnScroll>
                        </Col>
                    </Row>
                    <AnimationOnScroll animateIn={'animate__fadeIn'}>
                        <Row>
                            <Col xs={12} className="col employment-list">
                                <Accordion defaultActiveKey="0" className="cv-accordion">
                                    {cvItems}
                                </Accordion>
                            </Col>
                        </Row>
                    </AnimationOnScroll>
                    <Row>
                        <Col xs={12} className="col cta">
                            <div className="content-wrapper">
                                <h4>{strapline}</h4>
                                <AnimationOnScroll initiallyVisible={true} animateIn={'animate__headShake'} delay={1000}>
                                    <Button href={link} variant="mf-white" onClick={() => {
                                        gaEvent('event', 'CV CTA Click', 'link click');
                                        }}>
                                        {cta}
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </Button>
                                </AnimationOnScroll>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default CV;
